import { ArtistType, CompanyContactType } from '@api';
import { CompanyContactSelect, FormActions } from '@common';
import { Stack } from '@mantine/core';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ArtistContactsFormSchemaType, useArtistContactsForm } from './hooks';

const TRANS_PATH = 'CONTACTS.FORM';

type EditArtistContactsFormPropsType = {
  artist: ArtistType;
  agents: CompanyContactType[];
  buyers: CompanyContactType[];
  managers: CompanyContactType[];
  productManagers: CompanyContactType[];
  projectLeads: CompanyContactType[];
  coordinators: CompanyContactType[];
  onSubmit: (data: ArtistContactsFormSchemaType) => Promise<void>;
  onClose: () => void;
};

export const EditArtistContactsForm: React.FC<
  EditArtistContactsFormPropsType
> = ({
  artist,
  agents,
  buyers,
  managers,
  productManagers,
  projectLeads,
  coordinators,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation('artistDetailsGeneral');
  const form = useArtistContactsForm(artist);

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Stack>
          <CompanyContactSelect<ArtistContactsFormSchemaType>
            fieldName="agent"
            label={t(`${TRANS_PATH}.AGENT_LABEL`)}
            data={agents}
            clearable
            searchable
          />
          <CompanyContactSelect<ArtistContactsFormSchemaType>
            fieldName="buyer"
            label={t(`${TRANS_PATH}.BUYER_LABEL`)}
            data={buyers}
            clearable
            searchable
          />
          <CompanyContactSelect<ArtistContactsFormSchemaType>
            fieldName="manager"
            label={t(`${TRANS_PATH}.MANAGER_LABEL`)}
            data={managers}
            clearable
            searchable
          />
          <CompanyContactSelect<ArtistContactsFormSchemaType>
            fieldName="productManager"
            label={t(`${TRANS_PATH}.PRODUCT_MANAGER_LABEL`)}
            data={productManagers}
            clearable
            searchable
          />
          <CompanyContactSelect<ArtistContactsFormSchemaType>
            fieldName="projectLead"
            label={t(`${TRANS_PATH}.PROJECT_LEAD_LABEL`)}
            data={projectLeads}
            clearable
            searchable
          />
          <CompanyContactSelect<ArtistContactsFormSchemaType>
            fieldName="coordinator"
            label={t(`${TRANS_PATH}.COORDINATOR_LABEL`)}
            data={coordinators}
            clearable
            searchable
          />
          <FormActions
            onCancel={onClose}
            saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
            cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
          />
        </Stack>
      </form>
    </FormProvider>
  );
};
